import React from "react";
import "./ItemListEmail.css"

type ItemListEmailProps<T> = {
  item: T
  text: string
  onSelect: (item: T) => void
  className?: string
  //render: (item: T) => React.ReactNode
}

const ItemListEmail = <T,>({
    item,
    text,
    onSelect,
    className
    //render
}: ItemListEmailProps<T>) => {
    return (
        <div
        className="flex flex-ai-center flex-jc-sb pointer pl-14 pr-14 darks-white-bg option-input-notif"
        onClick={() => onSelect(item)}
        >
        {
            //render(item)
        
        }
        <p className={`fs-11 fw-400 ${className ?? ""}`}>{text}</p>
        </div>
    )
}

export default React.memo(ItemListEmail) as typeof ItemListEmail